import { useEffect, useState } from "react";
import { Swords, Crown, Trophy } from "lucide-react";
import api from "../api";
import { useUnit } from "../context/UnitContext";

const Ranking = ({ title, entries, fmt }) => (
  <div className="bg-[#14141A] border border-[#2E2E3A] flex-1">
    <p className="px-3 pt-2.5 pb-1 text-[10px] uppercase tracking-widest text-[#B0B0B4]">{title}</p>
    <div className="divide-y divide-white/5">
      {entries.map((e, i) => (
        <div key={e.name} className={`px-3 py-2 flex items-center gap-2 ${e.is_me ? "bg-[#FF3B30]/5" : ""}`}>
          {i === 0 ? <Crown size={15} className="text-amber-400 shrink-0" />
            : <span className="text-[#B0B0B4] font-mono text-xs w-[15px] text-center shrink-0">{i + 1}</span>}
          <p className="text-white text-xs font-medium truncate flex-1">{e.name}</p>
          <p className="text-[#ccc] font-mono text-xs shrink-0">{fmt(e)}</p>
        </div>
      ))}
    </div>
  </div>
);

export const ChallengeSection = () => {
  const { unit, dw } = useUnit();
  const [ch, setCh] = useState(null);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    api.get("/challenge").then(({ data }) => setCh(data)).catch(() => {});
    api.get("/challenge/history").then(({ data }) => setHistory(data)).catch(() => {});
  }, []);

  if (!ch || ch.volume.length === 0) return null;
  return (
    <section data-testid="challenge-section">
      <div className="flex items-center justify-between mb-2">
        <h2 className="font-display text-2xl text-white flex items-center gap-2">
          {ch.label.toUpperCase()} <Swords size={18} className="text-[#FF3B30]" />
        </h2>
        <span className="text-[10px] uppercase tracking-wider text-[#B0B0B4]">
          {ch.days_left} jour{ch.days_left > 1 ? "s" : ""} restant{ch.days_left > 1 ? "s" : ""}
        </span>
      </div>
      <div className="flex gap-2">
        <Ranking title={`Volume (${unit})`} entries={ch.volume} fmt={(e) => Math.round(dw(e.volume))} />
        <Ranking title="Séances" entries={ch.seances} fmt={(e) => e.seances} />
      </div>
      <p className="text-[#666] text-[10px] mt-1.5">La couronne 👑 revient au leader à la fin du mois. Que le meilleur gagne !</p>
      <div className="mt-3" data-testid="challenge-history">
        <p className="text-[10px] uppercase tracking-widest text-[#B0B0B4] mb-1.5 flex items-center gap-1.5">
          <Trophy size={12} className="text-amber-400" /> Palmarès des mois précédents
        </p>
        {history.length === 0 ? (
          <p className="text-[#666] text-xs bg-[#14141A] border border-[#2E2E3A] px-3 py-2.5">
            Aucun vainqueur encore — le premier sera couronné à la fin du mois !
          </p>
        ) : (
          <div className="bg-[#14141A] border border-[#2E2E3A] divide-y divide-white/5">
            {history.map((h) => (
              <div key={h.month} className="px-3 py-2.5">
                <p className="text-white text-xs font-semibold uppercase tracking-wider">{h.label}</p>
                <div className="flex gap-4 mt-1 text-xs">
                  <span className="text-[#ccc]">🏆 Volume : <span className="text-amber-400 font-medium">{h.volume_winner.name}</span> ({Math.round(dw(h.volume_winner.value))} {unit})</span>
                  <span className="text-[#ccc]">🏆 Séances : <span className="text-amber-400 font-medium">{h.seances_winner.name}</span> ({h.seances_winner.value})</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
